/**
 * Usage:
 *
 * data-shapejs-param-updater
 *
 */

var $ = require('./../sw-jquery');
var shapejsParamUpdater = require('./../../lib/views/ShapejsParamUpdater.js');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-shapejs-param-updater]').each(function() {
    var $el = $(this);

    new shapejsParamUpdater({
      el: $el
    });
  });

};
